import React from 'react';
//import SubCategorias from './SubCategorias';
//import firebase from './../Firestore'
import store from '../../store';

class EncabezadoCarrito extends React.Component {



onClick(){
  store.dispatch({
    type: "CARRITO"
  })
}

render() {

    return (
      <p className="py-2 my-0 text-center bg-danger align-middle"><span className="badge badge-warning mx-auto" onClick={event => this.onClick(event)}><i className="fas fa-shopping-cart" ></i> Ir al Carrito de compras</span></p>

    )
  }

}
export default EncabezadoCarrito
